import { AnchorButton } from "@blueprintjs/core";
import { Stack, Text } from "@mantine/core";

export const TimestampUpsellPopover = () => {
  return (
    <Stack sx={{ color: "black", width: "220px", whiteSpace: "break-spaces" }}>
      <Text color="gray">Last edited ****** ago</Text>
      <div>Create an account to see when a rule was last edited</div>
      <AnchorButton
        intent="primary"
        href={`/login?return_path=${window.location.pathname}`}
      >
        Sign up
      </AnchorButton>
    </Stack>
  );
};
